export const getCharWidth = (text: string) => {
  const canvasElement = document.createElement('canvas')
  const context = canvasElement.getContext('2d')

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return context?.measureText(text).width || 0
}
